export default __webpack_public_path__ + "static/media/ireland.b950426f.png";